<template>
  <div>
    <w-modal :active.sync="isActive" trap-focus
             aria-role="dialog"
             @close="onclose"
    >
      <div class="contentModal">
        <PopUpTitle class="titleBox" :title="$t('share.embed.modal.embedWeet')"/>
        <div class="columns">
          <div class="colLeft">
            <div class="switchBlock">
              <div class="labelSwitch">{{ $t('share.embed.modal.responsive') }}</div>
              <w-switch class="switch" v-model="isIFrameResponsive"/>
            </div>
            <div class="numberInputBox">
              <w-input :label="$t('share.embed.modal.height')" v-model="playerHeight"
                       type="number"
                       :enabled="!isIFrameResponsive"></w-input>
              <w-input :label="$t('share.embed.modal.width')" v-model="playerWidth"
                       type="number"
                       :enabled="!isIFrameResponsive"></w-input>
            </div>

          </div>
          <div class="colRight">
            <div class="previewButtonBox">
              <w-button v-if="!isPreview" size="small" color="light" @click="previewCode">
                {{ $t('share.embed.modal.showPreview') }}
              </w-button>
              <w-button v-else size="small" color="light" @click="hideCode">
                {{ $t('share.embed.modal.hidePreview') }}
              </w-button>
            </div>
            <Transition name="zoom">
              <div v-show="isPreview" class="inputPanel">
                <w-input type="textarea" size="small"
                         v-model="iFrame"></w-input>
              </div>
            </Transition>
          </div>
        </div>
        <w-button color="primary" class="buttonOk" @click="copyEmbedWeetCode">
          {{ $t('share.embed.modal.copyIFrame') }}
        </w-button>

      </div>
    </w-modal>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import store from '@/store';
import WButton from '@/components/wrapper/w-button.vue';
import {Weet} from '@/store/weet/weetModel';
import WModal from '@/components/wrapper/w-modal.vue';
import PopUpTitle from '@/components/title/PopUpTitle.vue';
import WError from '@/components/wrapper/w-error.vue';
import UserAvatar from '@/components/user/UserAvatar.vue';
import WInput from '@/components/wrapper/w-input.vue';
import WToolTip from '@/components/wrapper/w-toolTip.vue';
import {ActionEvent} from '@/enum/TrackerEnum';
import {setActionEvent} from '@/utils/tracker';
import WField from '@/components/wrapper/w-field.vue';
import WRadiobutton from '@/components/wrapper/w-radiobutton.vue';
import copy from 'copy-to-clipboard';
import CenterCenterPanel from '@/components/layout/CenterCenter.vue';
import WSwitch from '@/components/wrapper/w-switch.vue';
import {inform} from '@/utils/dialog';
import {ModalProgrammatic as Modal} from 'buefy';
import slugify from '@sindresorhus/slugify';
import {weetEmbedLink, weetLink} from '@/utils/weetUtil';


@Component({
  components: {
    WSwitch,
    CenterCenterPanel,
    WRadiobutton,
    WToolTip,
    WInput,
    UserAvatar,
    WError,
    PopUpTitle,
    WModal,
    WButton,
    WField
  },
  data() {
    return {tagsAvailable: store.getters.getContactsFiltered};
  }
})
export default class EmbedWeetModal extends Vue {
  @Prop()
  private weet!: Weet;

  @Prop({default: false})
  private active!: boolean;

  private isActive: boolean = this.active || false;
  private isIFrameResponsive: boolean = true;
  private playerWidth: number = 640;
  private playerHeight: number = 360;

  private isPreview: boolean = false;


  get iFrame(): string {
    const url = weetEmbedLink(this.weet);
    if (this.isIFrameResponsive) {
      let value = '<div style="position: relative; padding-bottom: 62.5%; height: 0;">';
      value += `<iframe id="weetPlayer" type="text/html" src="${url}" allowfullscreen `;
      value += ' allowfullscreen frameborder="0"';
      value += 'style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" >';
      value += '</iframe></div>';
      return value;
    } else {
      let value = `<iframe id="weetPlayer" type="text/html" src="${url}" allowfullscreen `;
      value += ' allowfullscreen frameborder="0"';
      value += `width="${this.playerWidth}" height="${this.playerHeight}"`;
      value += '</iframe>';
      return value;

    }
  }

  @Watch('active')
  public isActiveChange() {
    this.isActive = this.active;
  }

  private previewCode() {
    this.isPreview = true;
  }

  private hideCode() {
    this.isPreview = false;
  }

  private copyEmbedWeetCode() {
    setActionEvent(ActionEvent.player_button_share_embedded_weet,
        {weetID: this.weet.weetID});
    copy(this.iFrame);
    inform(this.$t('share.embed.modal.iFrameCopied').toString());

    this.close();


  }

  private close() {

    this.onclose();
    this.isActive = false;
  }

  private onclose() {
    this.$emit('close');
    this.$emit('update:active', false);
  }
}
</script>

<style scoped lang="scss">
.contentModal {
  background: #FFF;
  max-width: 600px;
  box-sizing: border-box;
  padding: 32px 32px 32px 32px;
  border-radius: 8px;
  margin: auto;
  position: relative;

  .titleBox {
    margin-bottom: 24px;
  }

  .columns {
    display: flex;

    .colLeft {
      margin-left: 16px;
      text-align: left;
      width: 50%;
      margin-right: 16px;

      .switchBlock {
        display: flex;

        .switch {
          margin-left: 16px;
        }
      }

      .numberInputBox {
        margin-top: 24px;
      }
    }

    .colRight {
      width: 50%;
      text-align: center;
      margin-left: 16px;

      .inputPanel {
        margin-left: 16px;
      }

      .previewButtonBox {
        margin-bottom: 48px;
      }
    }
  }
}

</style>
